import {t} from '@eitje/bridge'
import {notifications} from '~/components/notification'

export const validateMinMaxItems = (count, {minItems, maxItems}) => {
	if (minItems !== undefined && count < minItems) {
		notifications.errNotif(t('oops'), t('common.min_select', {count: minItems}))
		return false
	}
	if (maxItems !== undefined && count > maxItems) {
		notifications.errNotif(t('oops'), t('maxSelect', {count: maxItems}))
		return false
	}
	return true
}
